import { actions } from 'redux-rest-reducer';

import { RRRFetch } from '@cuemath/rest-api';
import getGlobalHeaders from '@~/constants/headers';

import { IS_DEV } from '../constants/app-config';

// app-type header to be sent in all requests to .cuemath.com
const config = {
  credentials: 'same-origin',
  headers: {
    ...getGlobalHeaders(),
  },
};

RRRFetch.setHeaders(getGlobalHeaders());

if (IS_DEV) {
  config.headers = {
    ...config.headers,
    'Learnosity-Host': 'local.cuemath.com',
  };
}

export default actions({ ...config });
